import { render, staticRenderFns } from "./giftcard-dialog.vue?vue&type=template&id=50cc0586&scoped=true&"
import script from "./giftcard-dialog.vue?vue&type=script&lang=js&"
export * from "./giftcard-dialog.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-dialog.vue?vue&type=style&index=0&id=50cc0586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cc0586",
  null
  
)

export default component.exports